// pages/UserAdmin/crm/erros.js
//
// Erro de requisição → frase que dá pra mostrar na tela.
//
// ─── Por que isto existe ───────────────────────────────────────────────
// O backend responde `detail` de duas formas diferentes, e só uma é texto:
//
//   HTTPException(422, "Telefone inválido.")   → detail: "Telefone inválido."
//   validação do próprio FastAPI               → detail: [{type, loc, msg, input}]
//
// A segunda acontece sem ninguém pedir — campo obrigatório ausente, tipo
// errado, multipart malformado. Jogar esse array direto num <Alert> levanta
// "Objects are not valid as a React child" e derruba a árvore inteira: em
// vez da mensagem de erro, a tela SOME. Foi exatamente o que aconteceu com
// o diálogo de importação (out/26) num 422 de upload.
//
// Então tudo passa por aqui, e o que sai é sempre string.

/** Mensagem legível de um erro de axios. `padrao` é o texto de reserva. */
export function mensagemDeErro(err, padrao = 'Algo deu errado. Tente de novo.') {
  const detail = err?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail;

  // Lista de erros de validação: junta os `msg`, dizendo qual campo quando
  // dá pra saber. `loc` vem como ["body", "file"] — o último item é o nome
  // do campo e é o único pedaço que significa algo pra quem lê.
  if (Array.isArray(detail) && detail.length) {
    const frases = detail
      .map((d) => {
        const msg = typeof d?.msg === 'string' ? d.msg : '';
        if (!msg) return '';
        const campo = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : '';
        return campo ? `${campo}: ${msg}` : msg;
      })
      .filter(Boolean);
    if (frases.length) return frases.join('; ');
  }

  // Objeto solto (ou detail ausente): não tenta adivinhar a forma, cai no
  // texto de reserva. Melhor uma frase genérica que a tela sumindo.
  if (typeof err?.message === 'string' && err.message && !err.response) {
    return err.message;
  }
  return padrao;
}

export default mensagemDeErro;
